import React from 'react';
import PropTypes from 'prop-types';

import { UnitIcon } from 'components/unit/UnitIcon';
import { Modal, ModalBody, ModalTitle } from 'components/core/Modal';
import { H3, Text, Paragraph } from 'components/core/Typography';
import { unitSizeOptions } from 'config/units';

import './UnitSizeModal.scss';

export function UnitSizeModal({ showing, onClose, unitSizes }) {
	return (
		<Modal
			className="unit-size-modal"
			showing={showing}
			onClose={onClose}
		>
			<ModalTitle>
				<H3
					last
					size="medium"
				>
					Unit Size Guide
				</H3>
			</ModalTitle>
			<ModalBody>
				<div className="unit-size-cards">
					{unitSizes.map((unitSize) => (
						<div
							className="unit-size-card"
							key={unitSize.title}
						>
							<div className="card-header">
								<span className="title">{unitSize.title}</span>
							</div>
							<div className="card-body">
								<UnitIcon
									type="storage"
									squareFootage={unitSize.sqft}
								/>
								<Text
									className="term"
									size="tiny"
								>
									This unit is:
								</Text>
								<Paragraph className="description">
									{unitSize.sqft} sq ft.
								</Paragraph>
								<Text
									className="term"
									size="tiny"
								>
									Looks like:
								</Text>
								<Paragraph className="description">
									{unitSize.looksLike}
								</Paragraph>
								<Text
									className="term"
									size="tiny"
								>
									What will fit:
								</Text>
								<Paragraph className="description">
									{unitSize.whatFits}
								</Paragraph>
							</div>
						</div>
					))}
				</div>
			</ModalBody>
		</Modal>
	);
}

UnitSizeModal.propTypes = {
	showing: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	unitSizes: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			sqft: PropTypes.number,
			looksLike: PropTypes.string,
			whatFits: PropTypes.string,
		}),
	),
};

UnitSizeModal.defaultProps = {
	unitSizes: unitSizeOptions,
};

export default UnitSizeModal;
